module.exports = __webpack_public_path__ + "img/5203299.e4eb6c35.jpg";